import React from 'react';
import './styles/DesignerStyles.css';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';

import DesignerButton from './DesignerButton';

import { checkForCode, getRoomId } from './Utils';

class Info extends React.Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  constructor(props) {
    super(props);

    // eslint-disable-next-line
    const { cookies } = props;

    this.state = {
      roomID: '',
      mostDifficultWord: '',
    };
  }

  componentDidMount() {
    checkForCode('GET', `/api/rooms/${getRoomId()}`, this.props, null).then(
      (data) => {
        // here we must present the data on the game statistics
        this.setState({
          room: data,
        });
      }
    );
  }

  handleGoBackButton = () => {
    this.props.navigate(`/RoundCompleted/${getRoomId()}`);
  };

  render() {
    return (
      <div className="Home">
        <h1 className="statisticsH1">Statistics</h1>

        <div className="arrowBackButtonDiv">
          <DesignerButton
            class="arrowBackButton"
            onClick={this.handleGoBackButton}></DesignerButton>
        </div>

        <div className="LongPaper">
          <p style={{ marginTop: '1px' }} className="PaperButtonParagraph">
            Most Difficult Word
          </p>
          <b className="PaperButtonParagraphBold">{'nai-trudna duma'}</b>
          <p className="PaperButtonParagraph">Most Guessed Word</p>
          <b className="PaperButtonParagraphBold">{'nai-lesna duma'}</b>
          <p className="PaperButtonParagraph">Best Player</p>
          <b className="PaperButtonParagraphBold">{'nai-dobriq igrach'}</b>
        </div>
      </div>
    );
  }
}

export default withCookies(Info);
